import React from 'react';
import { FormSectionProps } from '@/lib/formTypes';

export const PersonalInfoSection: React.FC<FormSectionProps> = ({
  data,
  errors,
  onChange,
}) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-xl font-bold text-[#1B4332] mb-6 text-right">
          חלק א': פרטים אישיים
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* First Name */}
        <div>
          <label className="block text-right mb-2">
            <span className="text-sm font-semibold text-[#1B4332]">שם פרטי</span>
            <span className="text-red-500 mr-1">*</span>
          </label>
          <input
            type="text"
            value={data.firstName || ''}
            onChange={(e) => onChange('firstName', e.target.value)}
            className={`w-full px-4 py-2 rounded-lg border-2 text-right focus:outline-none transition-colors ${
              errors.firstName
                ? 'border-red-500 focus:border-red-600'
                : 'border-[#E8A87C] focus:border-[#C17A4A]'
            }`}
            placeholder="שם פרטי"
          />
          {errors.firstName && (
            <p className="text-red-500 text-sm mt-1 text-right">{errors.firstName}</p>
          )}
        </div>

        {/* Last Name */}
        <div>
          <label className="block text-right mb-2">
            <span className="text-sm font-semibold text-[#1B4332]">שם משפחה</span>
            <span className="text-red-500 mr-1">*</span>
          </label>
          <input
            type="text"
            value={data.lastName || ''}
            onChange={(e) => onChange('lastName', e.target.value)}
            className={`w-full px-4 py-2 rounded-lg border-2 text-right focus:outline-none transition-colors ${
              errors.lastName
                ? 'border-red-500 focus:border-red-600'
                : 'border-[#E8A87C] focus:border-[#C17A4A]'
            }`}
            placeholder="שם משפחה"
          />
          {errors.lastName && (
            <p className="text-red-500 text-sm mt-1 text-right">{errors.lastName}</p>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Date of Birth */}
        <div>
          <label className="block text-right mb-2">
            <span className="text-sm font-semibold text-[#1B4332]">תאריך לידה</span>
            <span className="text-red-500 mr-1">*</span>
          </label>
          <input
            type="date"
            value={data.dateOfBirth || ''}
            onChange={(e) => onChange('dateOfBirth', e.target.value)}
            className={`w-full px-4 py-2 rounded-lg border-2 text-right focus:outline-none transition-colors ${
              errors.dateOfBirth
                ? 'border-red-500 focus:border-red-600'
                : 'border-[#E8A87C] focus:border-[#C17A4A]'
            }`}
          />
          {errors.dateOfBirth && (
            <p className="text-red-500 text-sm mt-1 text-right">{errors.dateOfBirth}</p>
          )}
        </div>

        {/* Phone */}
        <div>
          <label className="block text-right mb-2">
            <span className="text-sm font-semibold text-[#1B4332]">טלפון נייד</span>
            <span className="text-red-500 mr-1">*</span>
          </label>
          <input
            type="tel"
            value={data.phone || ''}
            onChange={(e) => onChange('phone', e.target.value)}
            className={`w-full px-4 py-2 rounded-lg border-2 text-right focus:outline-none transition-colors ${
              errors.phone
                ? 'border-red-500 focus:border-red-600'
                : 'border-[#E8A87C] focus:border-[#C17A4A]'
            }`}
            placeholder="0501234567"
          />
          {errors.phone && (
            <p className="text-red-500 text-sm mt-1 text-right">{errors.phone}</p>
          )}
        </div>
      </div>

      {/* Email */}
      <div>
        <label className="block text-right mb-2">
          <span className="text-sm font-semibold text-[#1B4332]">כתובת מייל</span>
          <span className="text-red-500 mr-1">*</span>
        </label>
        <input
          type="email"
          value={data.email || ''}
          onChange={(e) => onChange('email', e.target.value)}
          className={`w-full px-4 py-2 rounded-lg border-2 text-right focus:outline-none transition-colors ${
            errors.email
              ? 'border-red-500 focus:border-red-600'
              : 'border-[#E8A87C] focus:border-[#C17A4A]'
          }`}
          placeholder="example@email.com"
        />
        {errors.email && (
          <p className="text-red-500 text-sm mt-1 text-right">{errors.email}</p>
        )}
      </div>

      {/* Occupation */}
      <div>
        <label className="block text-right mb-2">
          <span className="text-sm font-semibold text-[#1B4332]">עיסוק</span>
        </label>
        <input
          type="text"
          value={data.occupation || ''}
          onChange={(e) => onChange('occupation', e.target.value)}
          className="w-full px-4 py-2 rounded-lg border-2 border-[#E8A87C] text-right focus:outline-none focus:border-[#C17A4A] transition-colors"
          placeholder="עיסוק (אופציונלי)"
        />
      </div>
    </div>
  );
};
